import { triggerOnPageLoadAnalytics, updateAnalyticsObj } from '../../../utils/analyticsHelpers';
import * as log from '../../../utils/log';
import { updateErrorContainer, updateErrorMessage, updateIsAuthenticate, updateIsLoading, updateOtpAttempts, updateOtpCode, updatePayload, updateRequiredErrorMsg, updateVerifyOtpScreen, resetOtpAction, updateisDidNotReceiveCode, updateSelectedTarget } from '../../store/actions/index';
import store from '../../store/index';
export default function OtpFormSession(formId, payload) {
    log.info('OtpFormSession::setAvailableTargets', {
        formId: formId,
        payload: payload
    }, 'component');
    store.dispatch(updatePayload(payload));
    var SFDDL = {};
    var createUi = function () {
        log.info('OtpFormSession::createUi', '', 'component');
        var errorMessage;
        var _a = store.getState(), analytics = _a.analytics, clientContext = _a.clientContext, config = _a.config, isdidNotReceiveCode = _a.isdidNotReceiveCode, params = _a.params, otpAttempts = _a.otpAttempts, otpCode = _a.otpCodeVerify, _b = _a.payload, phoneSecurityResponse = _b.phone_security_response, selectedPhoneNumber = _b.phone_numbers;
        if (formId === 'otp' &&
            payload.line_type &&
            payload.line_type.toLowerCase() !== 'mobile') {
            store.dispatch(updateIsAuthenticate(false));
            store.dispatch(updateErrorContainer(false));
        }
        if (formId === 'otp' &&
            payload.action_result === 'generate' &&
            payload.phone_numbers.length === 1) {
            if (clientContext.isSendAsVoiceEnabled === false) {
                store.dispatch(updateIsAuthenticate(false));
            }
            else if (clientContext.isSendAsVoiceEnabled === true) {
                store.dispatch(updateIsAuthenticate(true));
                if (phoneSecurityResponse) {
                    var errormessage = payload.sendCodeScreen.errorMessages.phoneSecurityResponseNotCleared;
                    store.dispatch(updateErrorContainer(true));
                    store.dispatch(updateOtpCode(''));
                    if (isdidNotReceiveCode) {
                        store.dispatch(updateErrorMessage(''));
                        store.dispatch(updateisDidNotReceiveCode(false));
                    }
                    else {
                        store.dispatch(updateErrorMessage(errormessage));
                    }
                }
                store.dispatch(updateVerifyOtpScreen(false));
            }
        }
        else {
            store.dispatch(updateIsAuthenticate(true));
        }
        if (formId === 'otp' &&
            payload.action_result === 'generate' &&
            payload.phone_numbers.length !== 1) {
            store.dispatch(updateIsAuthenticate(true));
            if (phoneSecurityResponse) {
                var errormessage = payload.sendCodeScreen.errorMessages.phoneSecurityResponseNotCleared;
                store.dispatch(updateErrorContainer(true));
                store.dispatch(updateOtpCode(''));
                if (isdidNotReceiveCode) {
                    store.dispatch(updateErrorMessage(''));
                    store.dispatch(updateisDidNotReceiveCode(false));
                }
                else {
                    store.dispatch(updateErrorMessage(errormessage));
                }
            }
            store.dispatch(updateVerifyOtpScreen(false));
            var buildAnalyticsObj = function () {
                var updatedAnalyticsObj = updateAnalyticsObj(SFDDL, analytics);
                if (params.channel_id === 'dapply') {
                    updatedAnalyticsObj.PageName = 'Transmit-OTP-Landing';
                }
                else if (params.channel === 'cal') {
                    updatedAnalyticsObj.PageName = 'start';
                    updatedAnalyticsObj.PageSubFunction = 'otp';
                }
                return updatedAnalyticsObj;
            };
            SFDDL = buildAnalyticsObj();
            if (config.custom.analyticsTrackerList.includes('Transmit-OTP-Landing')) {
                triggerOnPageLoadAnalytics(SFDDL, 'TRANSMIT_LANDING');
            }
            else if (config.custom.analyticsTrackerList.includes('start')) {
                triggerOnPageLoadAnalytics(SFDDL, 'SPA-PageLoad');
            }
            log.info('otpFormSession::createUi', '', 'component');
        }
        if (formId === 'otp' &&
            payload.line_type &&
            payload.line_type.toLowerCase() !== 'mobile') {
            store.dispatch(updateIsAuthenticate(false));
            store.dispatch(updateErrorContainer(false));
        }
        if (formId === 'otp' && payload.action_result === 'verify') {
            store.dispatch(updateIsAuthenticate(false));
            store.dispatch(updateErrorContainer(false));
            store.dispatch(updateVerifyOtpScreen(true));
            store.dispatch(updateSelectedTarget(selectedPhoneNumber));
            store.dispatch(updateRequiredErrorMsg(''));
            var otpCodeIsNumber = /^\d*$/.test(otpCode);
            if (otpCode !== '' &&
                otpCodeIsNumber &&
                otpCode.length === 5 &&
                otpAttempts >= 1) {
                var otpCount = otpAttempts + 1;
                store.dispatch(updateOtpAttempts(otpCount));
                errorMessage = payload.verifyCodeScreen.errorMessages.invalidCode;
                store.dispatch(updateErrorContainer(true));
                store.dispatch(updateErrorMessage(errorMessage));
                store.dispatch(updateOtpCode(''));
            }
            if (payload.resend_action === true) {
                var buildAnalyticsObj = function () {
                    var updatedAnalyticsObj = updateAnalyticsObj(SFDDL, analytics);
                    if (params.channel_id === 'dapply') {
                        updatedAnalyticsObj.PageName = 'Transmit-OTP-Verify';
                        updatedAnalyticsObj.PageSubFunction = 'First-attempt';
                    }
                    else if (params.channel === 'cal') {
                        updatedAnalyticsObj.PageName = 'enter code sent';
                        updatedAnalyticsObj.PageSubFunction = 'otp';
                    }
                    return updatedAnalyticsObj;
                };
                SFDDL = buildAnalyticsObj();
                if (config.custom.analyticsTrackerList.includes('First-attempt')) {
                    triggerOnPageLoadAnalytics(SFDDL, 'OTP_TRANSMIT_VERIFY');
                }
                else if (config.custom.analyticsTrackerList.includes('enter code sent')) {
                    triggerOnPageLoadAnalytics(SFDDL, 'SPA-PageLoad');
                }
            }
            else {
                var buildAnalyticsObj = function () {
                    var updatedAnalyticsObj = updateAnalyticsObj(SFDDL, analytics);
                    if (params.channel_id === 'dapply') {
                        updatedAnalyticsObj.PageName = 'Transmit-OTP-Verify';
                        updatedAnalyticsObj.PageSubFunction = 'Second-attempt';
                    }
                    return updatedAnalyticsObj;
                };
                SFDDL = buildAnalyticsObj();
                if (config.custom.analyticsTrackerList.includes('Second-attempt')) {
                    triggerOnPageLoadAnalytics(SFDDL, ' ');
                }
            }
            log.info('otpFormSession::createUi', '', 'component');
        }
    };
    var startSession = function () {
        store.dispatch(updateIsLoading(false));
        store.dispatch(resetOtpAction());
        createUi();
    };
    var promiseFormInput = function () {
        log.info('formSession::promiseFormInput', '', 'component');
        var sendCodeAs = '';
        var _a = store.getState(), clientContext = _a.clientContext, selectedPhoneNumber = _a.payload.phone_numbers;
        return new Promise(function (resolve) {
            var unsubscribe = store.subscribe(function () {
                var _a = store.getState(), otpAction = _a.otpAction, otpAttempts = _a.otpAttempts, otpCode = _a.otpCodeVerify, sendCode = _a.sendCode;
                if (otpAction === 'cancel') {
                    unsubscribe();
                    resolve(window.com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({
                        action: 'cancel'
                    }));
                }
                if (otpAction === 'didntReceiveCode') {
                    unsubscribe();
                    resolve(window.com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({
                        action: 'resend'
                    }));
                }
                if (otpAction === 'dontSeeNumber') {
                    unsubscribe();
                    resolve(window.com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({
                        action: 'donotSeeNumber'
                    }));
                }
                if (otpAction === 'sendOtp') {
                    var channelValue = sendCode;
                    if (clientContext.isSendAsVoiceEnabled) {
                        if (channelValue) {
                            sendCodeAs =
                                channelValue ===
                                    window.com.ts.mobile.sdk.OtpChannel.VoiceCall.toString()
                                    ? 'voice'
                                    : 'text';
                        }
                    }
                    else {
                        sendCodeAs = 'text';
                    }
                    if (selectedPhoneNumber !== '' && sendCodeAs !== '') {
                        unsubscribe();
                        resolve(window.com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({
                            selectedPhoneNumber: selectedPhoneNumber,
                            action: 'generate',
                            channel: sendCodeAs
                        }));
                    }
                }
                if (otpAction === 'verifyOtp') {
                    var otpCodeIsNumber = /^\d*$/.test(otpCode);
                    if (otpCode !== '' && otpCodeIsNumber && otpCode.length === 5) {
                        unsubscribe();
                        resolve(window.com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({
                            passcode: otpCode,
                            action: 'verify',
                            count: otpAttempts
                        }));
                    }
                }
            });
            if (formId === 'otp' &&
                payload.action_result === 'generate' &&
                payload.phone_numbers.length === 1 &&
                clientContext.isSendAsVoiceEnabled === false) {
                store.dispatch(updateErrorContainer(false));
                store.dispatch(updateErrorMessage(''));
                store.dispatch(updateIsLoading(true));
                resolve(window.com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({
                    selectedPhoneNumber: selectedPhoneNumber,
                    action: 'generate',
                    channel: 'text'
                }));
            }
            if (formId === 'otp' &&
                payload.line_type.toLowerCase() !== 'mobile' &&
                payload.action_result === null) {
                store.dispatch(updateErrorContainer(false));
                store.dispatch(updateErrorMessage(''));
                store.dispatch(updateSelectedTarget(payload.phone_numbers));
                store.dispatch(updateIsLoading(true));
                resolve(window.com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({
                    selectedPhoneNumber: payload.phone_numbers,
                    action: 'generate',
                    channel: 'voice'
                }));
            }
        });
    };
    var endSession = function () {
        log.info('formSession::endSession', '', 'component');
    };
    return {
        startSession: startSession,
        promiseFormInput: promiseFormInput,
        endSession: endSession,
        createUi: createUi
    };
}
